import { useTranslator } from "@eo-locale/react";

import auth0 from "auth0-js";

import { Button } from "@/storybook-components";
import { useAppSelector } from "@/redux/store/hooks";

const SingleSignOn = (): JSX.Element => {
  const { translate } = useTranslator();
  const { settings } = useAppSelector((state) => state.settings);
  const {
    enableActiveDirectorySignup,
    auth0Domain,
    auth0ClientId,
    auth0RedirectUrl,
    auth0Connection,
    ssoLoginPageMessage
  } = settings;

  const loginWithRedirect = () => {
    const webAuth = new auth0.WebAuth({
      domain: auth0Domain,
      clientID: auth0ClientId,
      redirectUri: auth0RedirectUrl + `?referer=${window.location.href}`,
      responseType: "code",
      scope: "openid profile email"
    });

    webAuth.authorize({
      connection: auth0Connection
    });
  };

  if (!enableActiveDirectorySignup) return null;

  return (
    <Button
      variant="secondary"
      my={3}
      size="lg"
      width="full"
      onClick={() => loginWithRedirect()}
      data-testid="login-participant-button-sso"
    >
      {ssoLoginPageMessage || translate("login.singleSignOn")}
    </Button>
  );
};

export default SingleSignOn;
